import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LanIcon from '@mui/icons-material/Lan';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import MapIcon from '@mui/icons-material/Map';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { Box, IconButton, List, useMediaQuery, useTheme } from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { ItsmRoutes } from '../../../itsm/itsm.routes';
import { NetworkServicesRoutes } from '../../../network-services/network-services.routes';
import { StatisticsRoutes } from '../../../statistics/statistics.routes';
import { AppRoutesConfig } from '../../config';
import { SidebarMenuItem, SideBarTopMenuItem } from '../SidebarMenuItem';

export const DesktopSidebarMenu: FunctionComponent = () => {
  const [wideMenu, setWideMenu] = useState<boolean>(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));

  if (isMobile) {
    return null;
  }

  const menuItems: SideBarTopMenuItem[] = [
    {
      labelTranslationKey: 'dashboard',
      icon: DashboardOutlinedIcon,
      navigation: AppRoutesConfig.Dashboard,
    },
    {
      labelTranslationKey: 'services',
      icon: LanIcon,
      children: [
        {
          labelTranslationKey: 'l3',
          navigation: `${AppRoutesConfig.Services}/${NetworkServicesRoutes.L3}`,
        },
      ],
    },
    {
      labelTranslationKey: 'itsmMaintenanceWorks',
      icon: LayersOutlinedIcon,
      navigation: `${AppRoutesConfig.Itsm}/${ItsmRoutes.MaintenanceWorks}`,
    },
    {
      labelTranslationKey: 'itsmNetworkServiceIncidents',
      icon: LayersOutlinedIcon,
      navigation: `${AppRoutesConfig.Itsm}/${ItsmRoutes.Incidents}`,
    },
    {
      labelTranslationKey: 'statistics',
      icon: NotificationsNoneIcon,
      children: [
        {
          labelTranslationKey: 'sla',
          navigation: `${AppRoutesConfig.Statistics}/${StatisticsRoutes.Sla}`,
        },
        {
          labelTranslationKey: 'cpe',
          navigation: `${AppRoutesConfig.Statistics}/${StatisticsRoutes.Cpe}`,
        },
        {
          labelTranslationKey: 'bitrate',
          navigation: `${AppRoutesConfig.Statistics}/${StatisticsRoutes.Bitrate}`,
        }
      ]
    },
    {
      labelTranslationKey: 'topology',
      icon: MapIcon,
      navigation: AppRoutesConfig.Topology,
    },
  ];

  const changeMenuDisplayMode = (): void => setWideMenu(value => !value);

  return <Box
    sx={{
      height: '100%',
      width: wideMenu ? 320 : 80,
      boxShadow: 2,
      justifyContent: wideMenu ? 'center' : 'start',
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: wideMenu ? 'start' : 'center', alignItems: 'center', p: 2 }}>
      <IconButton onClick={changeMenuDisplayMode}>
        <MenuIcon />
      </IconButton>
    </Box>
    <Box sx={{ mt: 4 }}>
      <List sx={{ color: '#232323', maxWidth: 280 }}>
        {menuItems.map(item => (<SidebarMenuItem
          key={item.labelTranslationKey}
          item={item}
          wideMenu={wideMenu}
        />))}
      </List>
    </Box>
  </Box>;
};